class ReleaseProducts extends HTMLElement {
  connectedCallback() {
    // Sort synchronously before the browser paints, so the user only ever
    // sees the sorted order. The container starts at opacity:0 via CSS, then
    // we toggle .is-sorted to fade it in.
    this.sortByReleaseTimestamp();
    this.classList.add('is-sorted');
  }

  sortByReleaseTimestamp() {
    const products = Array.from(this.querySelectorAll(':scope > [data-release-timestamp]'));
    if (products.length <= 1) return;

    products.sort((a, b) => {
      const aTs = Number(a.dataset.releaseTimestamp) || 0;
      const bTs = Number(b.dataset.releaseTimestamp) || 0;
      return aTs - bTs;
    });

    // appendChild() on an existing child moves it rather than duplicating,
    // so this rearranges in place without losing listeners or state.
    const fragment = document.createDocumentFragment();
    products.forEach((product) => fragment.appendChild(product));
    this.appendChild(fragment);
  }
}

customElements.define('release-products', ReleaseProducts);

class ReleaseSlider extends HTMLElement {
  connectedCallback() {
    // Same idea as ReleaseProducts, adapted for the slider markup:
    // sort the slides synchronously first, then let the (deferred) slider
    // initialise against the sorted order, then fade in via .is-sorted.
    this.sortByReleaseTimestamp();

    // The <slider-component> is marked data-wait-for-init so it doesn't set
    // itself up until we've reordered the slides. Init it once, now.
    const sliderComponent = this.querySelector('slider-component');
    if (sliderComponent && typeof sliderComponent.init === 'function') {
      sliderComponent.init();
    }

    // Reordering may move the first slide to the end, which leaves the scroll
    // position at the far right. Reset to the start before fading in.
    const slider = this.querySelector('[id^="Slider-"]');
    if (slider) slider.scrollLeft = 0;

    this.classList.add('is-sorted');
  }

  sortByReleaseTimestamp() {
    const slider = this.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll(':scope > [id^="Slide-"]'));
    if (slides.length <= 1) return;

    slides.sort((a, b) => {
      const aTs = Number(a.querySelector('[data-release-timestamp]')?.dataset.releaseTimestamp) || 0;
      const bTs = Number(b.querySelector('[data-release-timestamp]')?.dataset.releaseTimestamp) || 0;
      // Latest release first, oldest last.
      return bTs - aTs;
    });

    const fragment = document.createDocumentFragment();
    slides.forEach((slide) => fragment.appendChild(slide));
    slider.appendChild(fragment);
  }
}

customElements.define('release-slider', ReleaseSlider);
